<svg id="menu" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="26.425" height="17.626" viewBox="0 0 26.425 17.626">
  <defs>
    <clipPath id="clip-path">
      <rect id="Rectangle_2253" data-name="Rectangle 2253" width="26.425" height="17.626" transform="translate(0 0)" fill="#3c3c3b"/>
    </clipPath>
  </defs>
  <g id="Groupe_3954" data-name="Groupe 3954" clip-path="url(#clip-path)">
    <path id="Tracé_1417" data-name="Tracé 1417" d="M25.425,2H1A1,1,0,0,1,1,0H25.425a1,1,0,0,1,0,2" fill="#3c3c3b"/>
    <path id="Tracé_1418" data-name="Tracé 1418" d="M25.425,9.813H1a1,1,0,1,1,0-2H25.425a1,1,0,1,1,0,2" fill="#3c3c3b"/>
    <path id="Tracé_1419" data-name="Tracé 1419" d="M25.425,17.626H1a1,1,0,1,1,0-2H25.425a1,1,0,1,1,0,2" fill="#3c3c3b"/>
  </g>
</svg>
